import { ListSortDirection, Sort } from "../../models/api/sort";
import { TransactionStatusDTO, TransactionStatusSTO } from "../../models/transaction-statuses";
import { BaseApiService } from "../base/base-api.service";

export class TransactionStatusesApiService extends BaseApiService<TransactionStatusDTO, TransactionStatusSTO> {
  constructor() {
    super({
      servicePath: "/TransactionStatuses",
      loadItemsPath: "/GetTransactionStatuses",
      saveItemsPath: "/SaveTransactionStatuses",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
